import { render, staticRenderFns } from "./trainPerson.vue?vue&type=template&id=5aeaa7be&scoped=true"
import script from "./trainPerson.vue?vue&type=script&lang=js"
export * from "./trainPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeaa7be",
  null
  
)

export default component.exports